<template>
  <v-app-bar
    color="white"
    flat
    app
    clipped-left
    style="border-bottom: 0.1rem solid #714eff !important"
  >
    <v-img
      height="6rem"
      style="max-width: 10rem; width: 100%"
      contain
      src="../assets/APT_LogoR.png"
    ></v-img>
    <v-alert
      v-model="errorAlert"
      class="ma-2"
      v-if="apiErrorText"
      dense
      type="error"
      dismissible
      outlined
      >{{ apiErrorText }}
    </v-alert>
    <v-alert
      v-model="successAlert"
      class="ma-2"
      v-if="apiSuccessText"
      dense
      type="success"
      dismissible
      outlined
      >{{ apiSuccessText }}
    </v-alert>
    <v-spacer></v-spacer>
    <!-- <v-btn
      class="ma-2"
      color="primary"
      text
      v-if="profile.userType === USER_TYPE_STUDENT"
      style="
        font-weight: 600;
        font-size: 14rem;
        outline-color: #faaf19;
        outline-width: 1rem;
        outline-style: solid;
        color: white;
      "
      @click="toggleFullScreen()"
    >
      {{ fullScreenState ? "" : "Exit" }} Full screen
      <v-icon
        v-if="fullScreenState"
        dark
        color="white"
        class="ml-1 mr-0"
        size="20"
        >mdi-fullscreen
      </v-icon>
      <v-icon
        v-if="!fullScreenState"
        dark
        color="white"
        class="ml-1 mr-0"
        size="20"
        >mdi-fullscreen-exit
      </v-icon>
    </v-btn> -->
    <v-tooltip v-if="profile.userType === USER_TYPE_STUDENT" bottom>
      <template v-slot:activator="{ on }">
        <v-chip
          v-on="on"
          class="ma-2 font-weight-bold text-body-2"
          color="secondary"
          outlined
          @click="openleaderBoardDialog()"
        >
          <v-icon v-on="on" color="warning" class="mr-1" size="20"
            >mdi-trophy-outline</v-icon
          >{{ studentRank }}
        </v-chip>
      </template>
      <span>Leaderboard</span>
    </v-tooltip>
    <v-tooltip v-if="profile.userType === USER_TYPE_STUDENT" bottom>
      <template v-slot:activator="{ on }">
        <v-chip
          v-on="on"
          v-if="profile.aptCoins"
          class="font-weight-bold text-body-2"
          color="secondary"
          outlined
          @click="openCoinHistoryDialog"
        >
          <v-avatar left>
            <v-img src="../assets/Coin.svg"></v-img>
          </v-avatar>
          {{ profile.aptCoins }}
        </v-chip>
        <v-chip
          v-on="on"
          v-else
          color="secondary-chip font-weight-bold"
          style="font-size: 1rem"
        >
          <v-avatar left>
            <v-img src="../assets/Coin.svg"></v-img>
          </v-avatar>
          0
        </v-chip>
      </template>
      <span>Coin History</span>
    </v-tooltip>
    <v-chip
      v-if="profile"
      class="ma-2 primary-chip font-weight-bold text-body-2"
    >
      {{ profile.userType }}
    </v-chip>
    <v-btn class="text-body-2" color="error" @click="logout()" outlined>
      Logout
    </v-btn>
    <CoinHistoryDialog v-model="coinHistoryDialog" />
    <StudentLeaderBoardDialog
      v-model="leaderBoardDialog"
      :userId="profile.userId"
      :leaderBoard="leaderBoard"
    />
  </v-app-bar>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";

import Vue from "vue";
import CoinHistoryDialog from "@/components/dialogComponents/CoinHistoryDialog.vue";
import StudentLeaderBoardDialog from "@/components/dialogComponents/StudentLeaderBoardDialog.vue";
import {
  GET_USER_PROFILE,
  GET_API_ERROR_TEXT,
  GET_API_SUCCESS_TEXT,
  GET_TOKEN,
  GET_STUDENT_RANK,
} from "@/store/getters";
import { USER_TYPE_STUDENT } from "@/common/constants";
import {
  SET_API_ERROR,
  SET_API_SUCCESS,
  SET_OVERLAY_VALUE,
  SET_TOKEN_EXPIRED,
  SET_USER_PROFILE,
  SET_PARAMS_VALUE,
  SET_STUDENT_RANK,
  SET_COIN_BALANCE,
} from "@/store/mutations";
import {
  BASE_URL,
  LOGOUT_URL,
  STUDENT_LEADERBOARD,
} from "@/common/apiEndpoints";
import { getAxiosOptions } from "@/common/utility";
import axios from "axios";
export default Vue.extend({
  data() {
    return {
      errorAlert: false,
      successAlert: false,
      errorTimeout: "",
      successTimeout: "",
      USER_TYPE_STUDENT: USER_TYPE_STUDENT,
      fullScreenState: true,
      coinHistoryDialog: false,
      leaderBoardDialog: false,
      leaderBoard: [],
    };
  },
  components: {
    StudentLeaderBoardDialog,
    CoinHistoryDialog,
  },
  computed: {
    ...mapGetters({
      profile: `schoolModule/${GET_USER_PROFILE}`,
      apiErrorText: `schoolModule/${GET_API_ERROR_TEXT}`,
      apiSuccessText: `schoolModule/${GET_API_SUCCESS_TEXT}`,
      token: `schoolModule/${GET_TOKEN}`,
      studentRank: `schoolModule/${GET_STUDENT_RANK}`,
    }),
  },
  watch: {
    apiErrorText(newText) {
      if (newText) {
        this.errorAlert = true;
        this.clearErrorAlert();
      }
    },
    errorAlert(newValue) {
      if (!newValue) {
        clearTimeout(this.errorTimeout);
        this.setApiError("");
      }
    },
    apiSuccessText(newText) {
      if (newText) {
        this.successAlert = true;
        this.clearSuccessAlert();
      }
    },
    successAlert(newValue) {
      if (!newValue) {
        clearTimeout(this.successTimeout);
        this.setApiSuccess("");
      }
    },
    profile: {
      handler(profile) {
        if (
          profile.registrationCompleted &&
          profile.userType == this.USER_TYPE_STUDENT
        ) {
          this.getLeaderBoard();
        }
        if (profile.aptCoins && profile.userType == this.USER_TYPE_STUDENT) {
          this.setCoinBalance(profile.aptCoins);
        }
      },
    },
    // studentRank: {
    //   handler(studentRank) {
    //     if (studentRank) {
    //       this.studentRank = studentRank;
    //     }
    //   },
    //   immediate: true,
    // },
  },
  // destroyed() {
  //   // Remove the event listener for updating the fullscreen state when the app is destroyed
  //   document.removeEventListener(
  //     "fullscreenchange",
  //     this.updateFullScreenState
  //   );
  // },
  methods: {
    ...mapMutations({
      setApiError: `schoolModule/${SET_API_ERROR}`,
      setApiSuccess: `schoolModule/${SET_API_SUCCESS}`,
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
      setTokenExpired: `schoolModule/${SET_TOKEN_EXPIRED}`,
      setUserProfile: `schoolModule/${SET_USER_PROFILE}`,
      setParams: `schoolModule/${SET_PARAMS_VALUE}`,
      setStudentRank: `schoolModule/${SET_STUDENT_RANK}`,
      setCoinBalance: `schoolModule/${SET_COIN_BALANCE}`,
    }),
    getLeaderBoard() {
      let url = STUDENT_LEADERBOARD;
      axios
        .get(url, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.leaderBoard = res.data.leaderBoard;

          var studentRank = this.leaderBoard.find(
            (lb) => lb.userId == this.profile.userId
          ).rank;
          this.setStudentRank(studentRank);
        })
        .catch((error) => {
          error = error.errorMessage;
        });
    },
    openCoinHistoryDialog() {
      this.coinHistoryDialog = true;
    },
    openleaderBoardDialog() {
      this.leaderBoardDialog = true;
    },
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    },
    updateFullScreenState() {
      // Update the fullscreen state based on whether the document is in fullscreen mode
      this.fullScreenState = Boolean(!document.fullscreenElement);
    },
    clearErrorAlert: function () {
      const oThis = this;
      this.errorTimeout = setTimeout(function () {
        oThis.errorAlert = false;
      }, 4000);
    },
    clearSuccessAlert: function () {
      const oThis = this;
      this.successTimeout = setTimeout(function () {
        oThis.successAlert = false;
      }, 4000);
    },
    logout: function () {
      let url = LOGOUT_URL;
      axios
        .get(url, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          sessionStorage.clear();
          localStorage.clear();
          this.setParams({});
          this.$router.push({ path: "/login" }).catch(() => {});
          this.setTokenExpired(true);
          this.setOverlayValue(false);
          this.setUserProfile({});
        })
        .catch((error) => {
          error = error.errorMessage;
          sessionStorage.clear();
          localStorage.clear();
          this.setParams({});
          this.setTokenExpired(true);
          this.$router.push({ path: "/login" }).catch(() => {});
          this.setOverlayValue(false);
          this.setUserProfile({});
        });
    },
  },
});
</script>
<style scoped>
.main-app-baar {
  background-color: #f7f7f7;
  border: 0.1rem solid #d5d7e2;
  border-radius: 0.5rem !important;
  margin-top: 0.3rem !important;
  margin-right: 0.5rem !important;
  margin-left: 0.3rem;
}
</style>
